if not App.angularApp?
    return

App.angularApp.directive 'mfMentionInput', () ->
    return {
        restrict: 'A'
        require: ['^mfMentionContainer']
        link: (scope, elem, attrs, ctrls) =>

            Cont = ctrls[0]
            Model = ctrls[1]

            # store input element
            Cont.input_elem = elem

            # watch for @ and store following
            scope.$watch () =>
                return elem.val()
            , (val) =>
                if val.slice(-1) is '@' or Cont.get('is_open')
                    match = val.match(/(^|\s)@([\S]*)$/)
                    Cont.setPattern(match?[2], match?[2]?)
    }
